import request, { Methods, Options } from '@web/common/src/utils/requests/request';

const methods: Methods[] = ['get', 'post', 'delete', 'put'];

type HttpFn = {
  <T>(url: string, params?: any, options?: Options, config?: any): Promise<T>;
};
type Http = Record<Methods, HttpFn>;

// 新增CashLoan的request对象，CashLoan的接口定制化可在此处处理
export const clRequest: Http = methods.reduce((map: any, method: Methods) => {
  map[method] = (url: string, params?: any, options?: Options, config?: any) =>
    request[method](url, params, options, { ...config, productCode: 'CL' });
  return map;
}, {});

// 新增 CMC 的request对象
export const cmcRequest: Http = methods.reduce((map: any, method: Methods) => {
  map[method] = (url: string, params?: any, options?: Options, config?: any) =>
    request[method](url, params, options, { ...config, productCode: 'CMC' });
  return map;
}, {});
